import { useRef, useState, useEffect } from "react";
import { motion, animate } from "framer-motion";

const FADE_UP_INITIAL = { opacity: 0, y: 16 };
const FADE_UP_ANIMATE = { opacity: 1, y: 0 };

export const StatCounter = ({ id, to, prefix = "", suffix = "", label, delay = 0 }) => {
  const ref = useRef(null);
  const startedRef = useRef(false);
  const controlsRef = useRef(null);
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !startedRef.current) {
          startedRef.current = true;
          controlsRef.current = animate(0, to, {
            duration: 1.6,
            delay,
            ease: [0.16, 1, 0.3, 1],
            onUpdate: (v) => setDisplay(Math.round(v)),
          });
        }
      },
      { threshold: 0 }
    );
    observer.observe(el);
    return () => {
      observer.disconnect();
      controlsRef.current?.stop();
    };
  }, [to, delay]);

  return (
    <motion.div
      ref={ref}
      initial={FADE_UP_INITIAL}
      animate={FADE_UP_ANIMATE}
      transition={{ duration: 0.6, delay }}
      data-testid={`stat-counter-${id}`}
      className="flex flex-col"
    >
      <span className="font-heading font-black text-white text-3xl md:text-4xl tracking-tight leading-none">
        {prefix}{display}{suffix}
      </span>
      <span className="text-neutral-500 text-xs md:text-[13px] mt-1.5 font-medium">{label}</span>
    </motion.div>
  );
};
